import { useEffect, useState } from 'react';
import PMGProjectIcon from '../../assets/icons/pmg-project.svg';
import Button from '../../components/Button/Button';
import SearchBar from '../../components/Common/SearchBar/SearchBar';
import CustomPagination from '../../components/Common/CustomPagination/CustomPagination';
import CustomTable from '../../components/Common/CustomTable/CustomTable';
import { EditOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { addIoIndasDataMapping, editIoIndasDataMapping, getIoIndasDataMappingListing } from '../../redux/adminUnitReportSlice/adminUnitReportSlice';
import openNotification from '../../components/Common/OpenNotification';
import AddIoIndasData from '../../components/Modals/AddIoIndasData';
import { PATHNAME } from '../../pathname';
import { useNavigate } from 'react-router-dom';

const IoIndasDataMapping = () => {
        const [searchValue, setSearchValue] = useState('');
        const [currentPage, setCurrentPage] = useState(1);
        const [isModalOpen, setIsModalOpen] = useState(false);
        const [editProject, setEditProject] = useState({});
        const [ioNo, setIoNo] = useState('');
        const dispatch = useDispatch();
        const navigate = useNavigate();
        const { ioIndasDataMappingListing, totalIndasDataMappingListing } = useSelector((state) => state.unitReport);

        const handleAdd = async (formData) => {
                let response;
                if (editProject && Object.keys(editProject).length > 0) {
                        response = await dispatch(editIoIndasDataMapping(formData));
                } else {
                        response = await dispatch(addIoIndasDataMapping(formData));
                }

                const status = response?.payload?.status;

                if (status === 'success') {
                        dispatch(
                                getIoIndasDataMappingListing({
                                        page: currentPage,
                                        size: '10',
                                        search: searchValue,
                                }),
                        );
                        openNotification('success', editProject?.IO_NO ? 'Updated' : 'Added', 'Success');
                        setIsModalOpen(false); // ✅ Only close on success
                }

                return { status }; // ✅ Return status for child to handle
        };

        const pageSize = 10; // Items per page
        const columns = [
                {
                        title: 'IO Number',
                        dataIndex: 'IO_NO',
                        key: 'IO_NO',
                        width: 180,
                        fixed: 'left',
                        render: (text, record) => (
                                <div className="flex items-center justify-between gap-2">
                                        <span>{text}</span>
                                        <EditOutlined
                                                className="text-blue-500 cursor-pointer"
                                                onClick={() => {
                                                        setEditProject(record);
                                                        setIsModalOpen(true);
                                                }}
                                        />
                                </div>
                        ),
                },
                {
                        title: 'Rev No.',
                        dataIndex: 'REV_NO',
                        key: 'REV_NO',
                        width: 100,
                        render: (text) => <div className="text-right">{text}</div>,
                },
                {
                        title: 'Unit Code',
                        dataIndex: 'UNIT_CODE',
                        key: 'UNIT_CODE',
                        width: 120,
                        render: (text) => <div className="text-right">{text}</div>,
                },
                {
                        title: 'Cycle ID',
                        dataIndex: 'CYCLE_ID',
                        key: 'CYCLE_ID',
                        width: 120,
                        render: (text) => <div className="text-right">{text}</div>,
                },
                {
                        title: 'Allocation',
                        dataIndex: 'ALLOCATION',
                        key: 'ALLOCATION',
                        width: 140,
                        render: (text) => <div className="text-right">{text}</div>,
                },
                {
                        title: 'TCR',
                        dataIndex: 'TCR',
                        key: 'TCR',
                        width: 120,
                        render: (text) => <div className="text-right">{text}</div>,
                },
                {
                        title: 'TECC',
                        dataIndex: 'TECC',
                        key: 'TECC',
                        width: 120,
                        render: (text) => <div className="text-right">{text}</div>,
                },
                {
                        title: 'CCI',
                        dataIndex: 'CCI',
                        key: 'CCI',
                        width: 120,
                        render: (text) => <div className="text-right">{text}</div>,
                },
                {
                        title: 'Billed Upto',
                        dataIndex: 'BILLED_UPTO',
                        key: 'BILLED_UPTO',
                        width: 140,
                        render: (text) => <div className="text-right">{text}</div>,
                },
                {
                        title: 'PVC',
                        dataIndex: 'PVC',
                        key: 'PVC',
                        width: 100,
                        render: (text) => <div className="text-right">{text}</div>,
                },
                {
                        title: 'ERV',
                        dataIndex: 'ERV',
                        key: 'ERV',
                        width: 100,
                        render: (text) => <div className="text-right">{text}</div>,
                },
                {
                        title: 'Revenue Recognised Upto',
                        dataIndex: 'REVENUE_RECOGNISED_UPTO',
                        key: 'REVENUE_RECOGNISED_UPTO',
                        width: 200,
                        render: (text) => <div className="text-right">{text}</div>,
                },
                // {
                //         title: 'Upto Date',
                //         dataIndex: 'UPTO_DATE',
                //         key: 'UPTO_DATE',
                //         width: 140,
                //         render: (text) => <div className="text-right">{text}</div>,
                // },
                {
                        title: 'INDAS PID',
                        dataIndex: 'INDAS_PID',
                        key: 'INDAS_PID',
                        width: 140,
                        render: (text) => <div className="text-right">{text || '-'}</div>,
                },
                {
                        title: 'BS Unit',
                        dataIndex: 'BS_UNIT',
                        key: 'BS_UNIT',
                        width: 120,
                        render: (text) => <div className="text-right">{text || '-'}</div>,
                },
                 {
                        title: 'IS INDAS',
                        dataIndex: 'IS_INDAS',
                        key: 'IS_INDAS',
                        width: 120,
                        render: (value) => (
                                <div className="text-right">
                                        {Number(value) === 1 ? 'True' : 'False'}
                                </div>
                        ),
                },
        ];

        useEffect(() => {
                dispatch(
                        getIoIndasDataMappingListing({
                                page: currentPage,
                                size: '10',
                                search: searchValue,
                        }),
                );
        }, [currentPage, searchValue]);

        return (
                <div className="pb-14">
                        <div className="px-5 flex flex-col gap-6 pt-4">
                                <div className="flex gap-3">
                                        {/* <img
                                                src={PMGProjectIcon}
                                                alt="region"
                                        /> */}
                                        <div>
                                                <div className="font-inter font-semibold text-[18px] leading-[24px] tracking-[0%] text-[#101828]">ORDER ALLOCATION  DATA MAPPING</div>
                                                <div className="font-inter font-normal text-[14px] leading-[24px] tracking-[0%] text-[#475467]">List of internal order master</div>
                                        </div>
                                </div>
                                <div className="text-gray-500 text-sm flex justify-start">* All figures are in Rupees (in thousand).</div>
                                <div className="mt-[8px] flex justify-between">
                                        <SearchBar
                                                className="!w-[330px]"
                                                onSearch={setSearchValue}
                                                placeholder="Search by IO Number"
                                        />

                                        <div className="flex">
                                                <div className="mr-4">
                                                        <Button onClick={() => navigate(PATHNAME.ADMIN_UPLOAD_CSV_FILES_IO_INDAS_DATA_MAPPING)}
                                                                text="Upload"
                                                                variant="primary"
                                                        />

                                                </div>

                                                <div className="flex gap-[12px]">
                                                        <Button
                                                                text="+ Add Order Allocation  Data"
                                                                variant="primary"
                                                                onClick={() => {
                                                                        setIsModalOpen(true);
                                                                        setEditProject({});
                                                                }}
                                                        />
                                                </div>

                                        </div>

                                </div>
                                <div className=" flex flex-col gap-6">
                                        <CustomTable
                                                dataSource={ioIndasDataMappingListing}
                                                columns={columns}
                                        />
                                        <div>
                                                <CustomPagination
                                                        totalItems={totalIndasDataMappingListing}
                                                        pageSize={pageSize}
                                                        currentPage={currentPage}
                                                        setCurrentPage={setCurrentPage}
                                                />
                                        </div>
                                </div>
                                <AddIoIndasData
                                        open={isModalOpen}
                                        onCancel={() => {
                                                setIsModalOpen(false);
                                                setEditProject({});
                                        }}
                                        onSubmit={handleAdd}
                                        initialData={editProject}
                                        setEditIoIndasData={setEditProject}
                                />
                        </div>
                </div>
        );
};

export default IoIndasDataMapping;
